import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FnTimepickerService } from '../services/timepicker.service';
import { isNull } from '../../../util/check';

@Component({
  selector: 'fn-multi-time-picker',
  templateUrl: 'fn-multi-time-picker.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FnMultiTimePickerComponent implements OnInit {
  @Input() startIndex: number;
  @Input() lastIndex: number;
  @Input() placeHolder: string;
  @Input() isDisabled = false;
  @Input() isMilitryTime: boolean;
  @Input() isNextDayAllowed = true;
  @Input() appendTo: string;
  @Output() timeChanged: EventEmitter<{ firstIndex: number, lastIndex: number }> = new EventEmitter();


  timeStoredArray: Array<any> = [];
  uiItemArray: Array<any> = [];
  nonMilitryHourArray = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
  ];
  nonMilitryMinuteArray = [
    '00a',
    '00p',
    '15a',
    '15p',
    '30a',
    '30p',
    '45a',
    '45p',
  ];
  militryHourArray = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ];
  militryMinuteArray = ['00', '15', '30', '45'];
  showDropDown = true;
  checkEmpty = false;
  activeIndex = -1;

  searchTerm = '';
  oldSearchTerm = '';
  splitTimeVal: Array<string>;
  selectIndex: number;
  private KEY_CODES;

  constructor(private service: FnTimepickerService) {
    this.KEY_CODES = service.KEY_CODES;
  }

  ngOnInit() {
    if (this.isMilitryTime) {
      this.timeStoredArray = this.isNextDayAllowed ? this.service.Hour24NextFormat : this.service.Hour24Format;
    } else {
      this.timeStoredArray = this.isNextDayAllowed ? this.service.Hour12NextFormat : this.service.Hour12Format;
    }

    this.searchTerm =
      this.timeStoredArray[this.startIndex] +
      '-' +
      this.timeStoredArray[this.lastIndex];
    this.selectIndex = this.startIndex;
    this.emitTimeChangeEvent(this.searchTerm)
  }

  filterValue(event: KeyboardEvent | any) {
    this.showDropDown = true;
    if (typeof this.searchTerm !== 'undefined') {
      this.checkEmpty = false;
      this.splitTimeVal = this.searchTerm.split('-');

      if (this.splitTimeVal[1]) {
        const inputVal = this.splitTimeVal[1];
        if (!isNull(this.selectIndex)) {
          const splitFromTime = this.splitTimeVal[0].split(':');
          if (this.isMilitryTime) {
            if (
              this.militryHourArray.includes(splitFromTime[0]) &&
              this.militryMinuteArray.includes(splitFromTime[1])
            ) {
              if (this.isNextDayAllowed) {
                this.uiItemArray = this.service.Hour24NextFormat.filter(
                  items =>
                    items.toString().startsWith(inputVal) &&
                    this.service.Hour24NextFormat.indexOf(items) >
                    this.selectIndex
                );
              } else {
                this.uiItemArray = this.service.Hour24Format.filter(
                  items =>
                    items.toString().startsWith(inputVal) &&
                    this.service.Hour24NextFormat.indexOf(items) >
                    this.selectIndex
                );
              }


            } else {
              this.activeIndex = 0;
              this.uiItemArray = [];
            }
          } else {
            // this code written for matching regex for To time
            if (this.service.regex12a.test(inputVal)) {
              const timeStringSplit = inputVal.split('a');
              if (
                this.nonMilitryHourArray.includes(splitFromTime[0]) &&
                this.nonMilitryMinuteArray.includes(splitFromTime[1])
              ) {

                if (this.isNextDayAllowed) {
                  this.uiItemArray = this.service.Hour12NextFormat.filter(
                    items =>
                      items.toString().startsWith(timeStringSplit[0]) &&
                      items.includes('a') &&
                      this.service.Hour12NextFormat.indexOf(items) >
                      this.selectIndex
                  );
                } else {
                  this.uiItemArray = this.service.Hour12Format.filter(
                    items =>
                      items.toString().startsWith(timeStringSplit[0]) &&
                      items.includes('a') &&
                      this.service.Hour12Format.indexOf(items) >
                      this.selectIndex
                  );
                }

              } else {
                this.activeIndex = 0;
                this.uiItemArray = [];
              }
            } else if (this.service.regex12p.test(inputVal)) {
              const timeStringSplit = inputVal.split('p');
              if (
                this.nonMilitryHourArray.includes(splitFromTime[0]) &&
                this.nonMilitryMinuteArray.includes(splitFromTime[1])
              ) {

                if (this.isNextDayAllowed) {
                  this.uiItemArray = this.service.Hour12NextFormat.filter(
                    items =>
                      items.toString().startsWith(timeStringSplit[0]) &&
                      items.includes('p') &&
                      this.service.Hour12NextFormat.indexOf(items) >
                      this.selectIndex
                  );
                } else {
                  this.uiItemArray = this.service.Hour12Format.filter(
                    items =>
                      items.toString().startsWith(timeStringSplit[0]) &&
                      items.includes('p') &&
                      this.service.Hour12Format.indexOf(items) >
                      this.selectIndex
                  );
                }
              } else {
                this.activeIndex = 0;
                this.uiItemArray = [];
              }
            } else {
              if (
                this.nonMilitryHourArray.includes(splitFromTime[0]) &&
                this.nonMilitryMinuteArray.includes(splitFromTime[1])
              ) {

                if (this.isNextDayAllowed) {
                  this.uiItemArray = this.service.Hour12NextFormat.filter(
                    items =>
                      items.toString().startsWith(inputVal) &&
                      this.service.Hour12NextFormat.indexOf(items) >
                      this.selectIndex
                  );
                } else {
                  this.uiItemArray = this.service.Hour12Format.filter(
                    items =>
                      items.toString().startsWith(inputVal) &&
                      this.service.Hour12Format.indexOf(items) >
                      this.selectIndex
                  );
                }
              } else {
                this.activeIndex = 0;
                this.uiItemArray = [];
              }
            }
          }
        }
      } else {
        if (this.service.regex12a.test(this.searchTerm)) {
          const timeStringSplit = this.searchTerm.split('a');
          this.uiItemArray = this.timeStoredArray.filter(
            items => items.includes(timeStringSplit[0]) && items.includes('a')
          );
        } else if (this.service.regex12p.test(this.searchTerm)) {
          const timeStringSplit = this.searchTerm.split('p');
          this.uiItemArray = this.timeStoredArray.filter(
            items => items.includes(timeStringSplit[0]) && items.includes('p')
          );
        } else {
          if (this.isMilitryTime) {
            const term = this.searchTerm.toString().split(':');
            // tslint:disable-next-line:radix max-line-length
            const modifiedTerm =
              parseInt(term[0]) < 10 && !term[0].toString().startsWith('0')
                ? '0' + term[0] + (term.length > 1 ? ':' + term[1] : '')
                : this.searchTerm;
            this.uiItemArray = this.timeStoredArray.filter(items =>
              items.toString().startsWith(modifiedTerm)
            );
          } else {
            this.uiItemArray = this.timeStoredArray.filter(items =>
              items.toString().startsWith(this.searchTerm)
            );
          }
        }
      }

      if (event.keyCode === this.KEY_CODES.BACKSPACE) {
        this.activeIndex = 0;
        if (this.uiItemArray.length > 0) {
          this.setDropdownScrollTop(0);
        }
      }

      if (
        event.keyCode === this.KEY_CODES.ENTER &&
        this.uiItemArray.length > 0
      ) {
        const liVal = document.querySelector('li.active').textContent;
        this.onItemClick(liVal);
        this.activeIndex = 0;
        this.uiItemArray = [];
        this.setDropdownScrollTop(0);
        this.checkEmpty = false;
      }
    } else {
      this.activeIndex = 0;
      this.checkEmpty = true;
      this.uiItemArray = [];
    }
    if (this.oldSearchTerm !== this.searchTerm) {
      this.emitTimeChangeEvent(this.searchTerm);
    }
  }

  private emitTimeChangeEvent(value: string) {
    const splitString = value.split('-');
    let firstIndex = this.timeStoredArray.indexOf(splitString[0]);
    let lastIndex = this.timeStoredArray.indexOf(splitString[1]);
    this.timeChanged.emit({ firstIndex, lastIndex });
  }

  onItemClick(param: string) {
    if (this.splitTimeVal[1]) {
      this.activeIndex = 0;
      const newToTimeString = this.searchTerm.split('-')[0];
      this.searchTerm = newToTimeString + '-' + param;
      this.uiItemArray = [];
    } else {
      this.activeIndex = 0;
      this.searchTerm = param + '-';
      this.selectIndex = this.timeStoredArray.indexOf(param);
      this.uiItemArray = [];
    }
    if (this.oldSearchTerm !== this.searchTerm) {
      this.emitTimeChangeEvent(this.searchTerm);
    }
  }

  closeDropDown() {
    this.showDropDown = false;
  }

  openDropDown(event: any) {
    this.showDropDown = true;
    if (this.checkEmpty) {
      this.filterValue(event);
    }
  }

  keyDownChange(event: KeyboardEvent): void {
    if (event.code === this.KEY_CODES.ARROW_UP && this.activeIndex > 0) {
      this.activeIndex--;
      this.setDropdownScrollTop(-35, false);
    }
    if (
      event.code === this.KEY_CODES.ARROW_DOWN &&
      this.activeIndex < this.uiItemArray.length - 1
    ) {
      this.activeIndex++;
      this.setDropdownScrollTop(35, false);
    }
    this.oldSearchTerm = this.searchTerm;
  }

  private setDropdownScrollTop(value: number, isReset = true) {
    const dropDownElem = document.getElementsByClassName('fn-time-picker-ul')[0];
    if (dropDownElem) {
      dropDownElem.scrollTop = (isReset ? value : dropDownElem.scrollTop + value);
    } else {
      setTimeout(() => {
        this.setDropdownScrollTop(value, isReset)
      }, 100)
    }
  }
}
